module.exports = __webpack_public_path__ + "img/Real-Betis.d7e0285c.png";